export default "__VITE_ASSET__CopSe2ds__"